<template>
  <el-form ref="ref_form" class="set-game-options" :model="interferenceForm" label-width="150px">
    <el-form-item label="页面选项" prop="optionNum">
      <el-radio-group v-model="interferenceForm.optionNum">
        <el-radio :label="2">两个选项</el-radio>
        <el-radio :label="3">三个选项</el-radio>
      </el-radio-group>
    </el-form-item>
    <div v-for="(item, index) in interferenceForm.dataList" :key="index" class="setGame5">
      <el-form-item
        v-if="courseData.curriculumType === 'READING' || courseData.curriculumType === 'SENTENCE' || courseData.curriculumType === 'REVIEWREADING' || courseData.curriculumType === 'REVIEWSENTENCE' || courseData.curriculumType === 'TESTREADING' || courseData.curriculumType === 'TESTSENTENCE'"
        :label="'学习内容' + (index + 1)"
        :prop="'dataList.' + index + '.studyId'"
        :rules="{
          required: true, message: '请选择', trigger: 'change'
        }"
      >
        <el-select v-model="item.studyId" placeholder="请选择" filterable style="width: 500px;" @change="sentenceChange($event, index)">
          <el-option v-for="sentence in item.sentenceList" :key="sentence.id" :label="sentence.desc" :value="sentence.id" />
        </el-select>
      </el-form-item>
      <el-form-item v-else :label="'学习内容' + (index + 1)" prop="name">
        <el-input v-model="item.name" disabled style="width: 350px;" />
      </el-form-item>
      <el-form-item
        label="选择填空词"
        :prop="'dataList.' + index + '.chooseWords'"
        :rules="{
          required: true, message: '请选择填空词', trigger: 'change'
        }"
      >
        <el-radio-group v-model="item.chooseWords" size="medium" style="margin-bottom: : 20px;">
          <el-radio-button v-for="(word, index2) in item.studySentence" :key="index2" :label="word">{{ word }}</el-radio-button>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="自定义干扰项" required>
        <el-button type="success" size="small" :disabled="item.interfereCardList.length >= 2" @click="addCustomerInterfereCard(index)">添加干扰项</el-button>
        <br>
        <div v-for="(item3, index3) in item.interfereCardList" :key="index3" class="interfereCard">
          <div class="cont">
            <el-form-item label="内容" label-width="60px" style="margin-bottom: 10px;">
              <el-input v-model="item3.wordName" maxlength="20" placeholder="请输入单词/字母名称" />
            </el-form-item>
          </div>
          <el-button type="warning" size="small" @click="deleteCustomerInterfereCard(index, index3)">删除</el-button>
        </div>
      </el-form-item>

    </div>
  </el-form>
</template>

<script>
import { mapState } from 'vuex'
import { saveConfData } from '@api/courseManagement/api_quiz'
// import themeUploadAvatar from '../../components/themeUploadAvatar'
// import uploadList from '@/components/Upload/uploadList.vue'
// import { getDictoryInfoByCode } from '@/api/api_common.js'
export default {
  components: {
    // themeUploadAvatar
  },
  props: {
    timestamp: {
      type: Number,
      default: 0
    },
    moduleType: {
      type: String,
      default: ''
    },
    currentQuizType: {
      type: String,
      default: ''
    },
    gameList: {
      type: Array,
      default: function () {
        return []
      }
    },
    interferenceList: {
      type: Array,
      default: function () {
        return []
      }
    },
    interferenceList2: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      interferenceForm: {
        optionNum: 2,
        dataList: [
        ]
      }

    }
  },
  computed: {
    ...mapState('courseStep', ['courseData', 'stepOptions', 'stepActive'])
  },
  watch: {
    gameList: function (val) {
      this.interferenceForm.dataList = []
      this.interferenceForm.optionNum = val[0].optionNum ? val[0].optionNum : 2
      this.gameList.forEach((item, index) => {
        const studyId = item.studyId || item.sentenceList[0].id

        const obj = {
          state: item.state,
          studyId: studyId,
          name: item.wordName,
          chooseWords: item.chooseWords,
          interfereIdstr: item.interfereIdList.toString(),
          meansType: item.meansType,
          interfereCustomMeans: [

          ],
          sentenceList: item.sentenceList,
          // 选中studyId对应的句子
          studySentence: '',
          interfereCardList: []
        }

        this.interferenceForm.dataList.push(obj)

        const interfereCardList = item.interfereCustomMeans ? item.interfereCustomMeans : []
        for (const item2 of interfereCardList) {
          this.interferenceForm.dataList[index].interfereCardList.push({ wordName: item2.wordName })
        }

        // 对于已选中的句子，初始化时处理将句子切割为单词
        this.sentenceChange(studyId, index)
      })
    }
  },

  created () {

  },
  methods: {
    sentenceChange (val, index) {
      // 阅读模块 和 句型模块，学习内容更改时，将选中的对应句子
      const arr = this.interferenceForm.dataList[index].sentenceList
      let name = ''
      for (const item of arr) {
        if (item.id === val) {
          name = item.desc
          break
        }
      }
      this.interferenceForm.dataList[index].studySentence = this.getWordsBySentence(name)
    },
    getWordsBySentence (sentence) {
      const sentenceStr = sentence.replace(/[|\~|\`|\!|\@|\#|\$|\%|\^|\&|\*|\(|\)|\-|\_|\+|\=|\||\\|\[|\]|\{|\}|\;|\:|\"|\'|\,|\<|\.|\>|\/|\?/\，/\。/\；/\：/\“/\”/\》/\《/\|/\{/\}/\、/\!/\~/\`]/g, ' ')
      let words = sentenceStr.split(' ')
      words = words.filter(item => {
        return item
      })
      return words
    },
    getOptions () {

      // getDictoryInfoByCode ('').then(res => {  })
    },
    // 根据游戏类型 和 meansType 判断 干扰项取值
    interferenceListOptions (item) {
      if (this.currentQuizType === '4003') {
        return this.interferenceList
      } else if (this.currentQuizType === '2002') {
        return this.interferenceList
      } else if (item.meansType === '1') {
        return this.interferenceList
      } else {
        return this.interferenceList2
      }
    },
    addCustomerInterfereCard (index) {
      this.interferenceForm.dataList[index].interfereCardList.push({ wordName: '' })
    },
    deleteCustomerInterfereCard (index, index3) {
      this.$confirm('是否确认删除干扰项?', '提示', {
        type: 'warning',
        closeOnClickModal: false
      }).then(() => {
        this.interferenceForm.dataList[index].interfereCardList.splice(index3, 1)
      })
    },
    // 验证干扰项 选择必填项
    isValidateOptions (arr) {
      let flag = false
      // const arr = _.cloneDeep(this.interferenceForm.dataList)
      for (let i = 0; i < arr.length; i++) {
        for (var j = 0; j < arr[i].interfereCardList.length; j++) {
          if (arr[i].interfereCardList[j].wordName === '') {
            this.$message.error(`学习内容${i + 1}自定义干扰项信息未填写完整`)
            flag = true
            return flag
          }
        }

        if (arr[i].interfereCardList.length !== (this.interferenceForm.optionNum - 1)) {
          this.$message.error(`学习内容${i + 1}干扰项数量与页面选项数不符`)
          flag = true
          return flag
        }
      }
      return flag
    },
    saveGameOptions () {
      this.$refs.ref_form.validate(valid => {
        if (!valid) { return false }
        if (this.isValidateOptions(this.interferenceForm.dataList)) {
          return false
        }

        this.interferenceForm.dataList.forEach(item => {
          item.interfereCustomMeans = item.interfereCardList
        })
        const params = {
          curriculumId: this.courseData.teachingCurriculumId,
          curriculumType: this.courseData.curriculumType,
          quizType: this.currentQuizType,

          optionNum: this.interferenceForm.optionNum,
          items: this.interferenceForm.dataList
        }
        saveConfData(params).then(res => {
          this.$message.success('操作成功')
          this.$emit('finishSave')
        })
      })
    }
  }
}
</script>

<style lang='scss'>
.setGame5{
  border-bottom: 1px solid #ddd;
  padding-bottom: 10px;
  margin-bottom: 30px;
}

</style>
